import React from 'react';

const Card = (props) => {
    const { gun } = props;
    const { price, name, img, category, capacity, action } = gun;
    return (
        <div>
            <div className="card w-96 h-full bg-base-100 shadow-xl">
                <figure>< img src={img} alt="Shoes" className='h-80 w-full' /></figure>
                <div className="card-body">
                    <h2 className="card-title">
                        {name}
                        <div className="badge badge-secondary">{capacity}</div>
                    </h2>
                    <p>{action}</p>
                    <div className="flex items-center justify-between">
                    <button class="btn btn-sm btn-primary" onClick={props.increaseValue} >Add to Cart</button>

                        <div className="card-actions">
                            <div className="badge badge-outline">{category}</div>
                            <div className="badge badge-outline">{price}</div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Card;